import { render } from "./CurrencyInput.vue?vue&type=template&id=6f2b7737&scoped=true&bindings={\"modelValue\":\"props\",\"currency\":\"props\",\"distractionFree\":\"props\",\"locale\":\"props\",\"inputRef\":\"setup\",\"formattedValue\":\"setup\"}"
import script from "./CurrencyInput.vue?vue&type=script&lang=js"
export * from "./CurrencyInput.vue?vue&type=script&lang=js"

import "./CurrencyInput.vue?vue&type=style&index=0&id=6f2b7737&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6f2b7737"

export default script